export default "__VITE_ASSET__aa75d1f6__"